<template>
  <div class="pt-list w-full border border-grey-light rounded">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PtList',
  props: {
    isCollapsible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
